import React from 'react';
import GLOBALS from '../config/globals';

const AboutPage = () => {
    return (
        <div className="container">
            <h1 className="header">About</h1>

            <h2>Uranium Baseball</h2>
            <div className="paragraph">
                Uranium Baseball is a dice-based digital baseball card game. Collect player cards, build a roster of 24, and compete in simulated baseball games against AI opponents or other users. Every at-bat is resolved by dice rolls against your players' cards — strategy comes from roster construction, lineup decisions, and pitching management.
            </div>

            <h2>The Company</h2>
            <div className="paragraph">
                Uranium Baseball is developed and published by <b>URANIUM LLC</b>, a Washington State company.
            </div>

            <h2>Contact</h2>
            <div className="paragraph">
                The best way to reach us is through the{' '}
                <a href={GLOBALS.DISCORD_INVITE_URL} target="_blank" rel="noopener noreferrer">
                    Uranium Baseball Discord server
                </a>
                . Bug reports, feedback, and feature requests are all welcome there.
            </div>
        </div>
    );
};

export default AboutPage;
